<!-- eslint-disable -->
<template lang="pug">
    div.generator-form
        div.generator-form__divider
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_generator_comment')")
            cs-input(v-model="selectedGame.text")
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_difficulty')")
            cs-multiselect(
                :multiple="false",
                :options="difficult",
                :show-labels="false",
                :allow-empty="false",
                placeholder="",
                label="label",
                :value="{label: $i18n.t('common')[selectedGame.parameters.difficult], name: selectedGame.parameters.difficult}"
                @select="selectDifficult"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_numOfExamples')")
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.amountOfExamples",
                :options="examples",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_numOfActions')")
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.amountOfActions",
                :firstNumber="2",
                :options="actions",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_numOfUnknowns')")
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.amountOfUnknowns",
                :options="selectedGame.parameters.amountOfActions - 1",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_negativeAnswers')")
            cs-checkbox.generator-form__checkbox(v-model="selectedGame.parameters.negativeAnswers")
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_fractions')")
            cs-checkbox.generator-form__checkbox(
                :checked="selectedGame.parameters.fractions"
                @change="fractionsHandler"
            )
        form-group.generator-form__form-group(
            v-if="selectedGame.parameters.fractions",
            :label="$i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints')"
        )
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.fractionalPart",
                :options="fractionalParts",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits')")
            cs-checkbox.generator-form__checkbox(
                :checked="selectedGame.parameters.combining",
                :disabled="selectedGame.parameters.difficult === 'Однозначные цифры'",
                @change="combiningHandler"
            )
        form-group.generator-form__form-group(v-if="selectedGame.parameters.combining && !selectedGame.parameters.fractions", label=" ")
            div.generator-form__numbers-container
                combining-digit-capacities(
                    :combiningDigitCapacityLabels="combiningDigitCapacityLabels",
                    :filteredCombiningDigitCapacities="filteredCombiningDigitCapacities",
                    :combiningDigitCapacities="selectedGame.parameters.combiningDigitCapacities",
                    @changeCombiningDigitCapacities="changeCombiningDigitCapacities"
                )
</template>

<script>
    /*eslint-disable*/
    import CombiningDigitCapacities from './shared/CombiningDigitCapacity.vue'
    import combiningCapacitiesMixin from './utils/combiningCapacitiesMixin'

    export default {
        components: {
            CombiningDigitCapacities
        },
        props: {
            selectedGame: Object
        },
        mixins: [combiningCapacitiesMixin],
        data() {
            return {
                difficult: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                    }
                ],
                examples: 100,
                actions: 10,
                fractionalParts: 2,
                combiningDigitCapacities: [1, 2, 3, 4, 5],
                combiningDigitCapacityLabels: {
                    1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                    2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                    3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                    4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                    5: this.$i18n.t('common.common_gameSetting_digitCapacity5')
                },
                difficultKeys: {
                    'Однозначные цифры': 1,
                    'Двузначные цифры': 2,
                    'Трехзначные цифры': 3,
                    'Четырехзначные цифры': 4,
                    'Пятизначные цифры': 5
                }
            }
        },
        watch: {
            'selectedGame.parameters.difficult'(val) {
                if (val === 'Однозначные цифры') {
                    this.selectedGame.parameters.combining = false;
                }
            },
            'selectedGame.parameters.amountOfActions'(val) {
                if (this.selectedGame.parameters.amountOfUnknowns >= +val) {
                    this.selectedGame.parameters.amountOfUnknowns = +val - 1;
                }
            }
        },
        methods: {
            combiningHandler(combining) {
                this.selectedGame.parameters.combining = combining;
                this.selectedGame.parameters.combiningDigitCapacities = [];
                if (combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            selectDifficult(difficult) {
                this.selectedGame.parameters.difficult = difficult.name;
                if (this.selectedGame.parameters.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            fractionsHandler(fractions) {
                this.selectedGame.parameters.fractions = fractions;
                if (this.selectedGame.parameters.combining) {
                    this.fillCombiningDigitCapacities();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .generator-form {
        @include stack-space($space-large);

        &__divider {
            @include stack-space($space-base);
            border-bottom: 1px solid $color-grey-300;
        }

        &__select {
            width: 100%;
        }

        &__form-group {
            @include stack-space($space-base);
        }

        &__checkbox {
            @include inline-space($space-base);
        }
    }
</style>